import React, {useState, useEffect, useContext, useRef} from 'react';
import axios from "../common/axios";
import {BrandContext} from "../common/BrandContext";
import {ContentContext} from "../common/ContentContext";
import CircularLoader from "../common/CircularLoader";
import Tab from "../common/Tab";
import Tabs from "../common/Tabs";

const CMSSearch = props => {
    const [isLoading, setLoading] = useState(true);
    const [contentTabHTML, setContentTabHTML] = useState();
    const [mediaTabHTML, setMediaTabHTML] = useState();
    const [questionTabHTML, setQuestionTabHTML] = useState();
    const [questionSetTabHTML, setQuestionSetTabHTML] = useState();
    const [tabType, setTabType] = useState('CONTENT');
    const contentTabDivRef = useRef();
    const mediaTabDivRef = useRef();
    const questionTabDivRef = useRef();
    const questionSetTabDivRef = useRef();

    useEffect(() => {
        if(tabType == 'CONTENT') {
            setLoading(true);
            axios.get('/administration/content/showSearchContentHeader.action')
                .then(response => {
                    updateTabContent(response.data, contentTabDivRef);
                    setLoading(false);
                });
        } else if(tabType == 'MEDIA') {
            setLoading(true);
            axios.get('/administration/media/showSearchMediaHeader.action')
                .then(response => {
                    updateTabContent(response.data, mediaTabDivRef);
                    setLoading(false);
                });
        } else if(tabType == 'QUESTION') {
            setLoading(true);
            axios.get('/administration/question/showSearchQuestionsHeader.action')
                .then(response => {
                    updateTabContent(response.data, questionTabDivRef);
                    setLoading(false);
                });
        } else if(tabType == 'QUESTION_SET') {
            setLoading(true);
            axios.get('/administration/question/showSearchQuestionClustersHeader.action')
                .then(response => {
                    updateTabContent(response.data, questionSetTabDivRef);
                    setLoading(false);
                });
        }

    }, [tabType]);

    const updateTabContent = (tabContent, tabDivRef) => {
        try {
            if (tabContent != undefined && tabDivRef != undefined && tabDivRef.current != undefined) {
                const htmlFragment = document.createRange().createContextualFragment(tabContent);
                tabDivRef.current.innerHTML = '';
                tabDivRef.current.appendChild(htmlFragment);
                $(tabDivRef.current).reloadMathJax();
            }
        } catch (e) {
            console.error('Error loading tab content', e);
            if (typeof newrelic !== 'undefined') {
                newrelic.noticeError('Lesson error: ' + e);
            }
        }
    }

    return (
        <>
            <Tabs defaultActiveKey={0} className="flexMax">
                <Tab tab={'Content'} tabpanelclassname={'ch-search-items-blk'} onClick={()=>{setTabType('CONTENT')}}>
                    <div id={'cmsHeaderContentSearch'} ref={contentTabDivRef}></div>
                </Tab>
                <Tab tab={'Media'} tabpanelclassname={'ch-search-items-blk'} onClick={()=>{setTabType('MEDIA')}}>
                    <div id={'cmsHeaderMediaSearch'} ref={mediaTabDivRef}></div>
                </Tab>
                <Tab tab={'Question'} tabpanelclassname={'ch-search-items-blk'} onClick={()=>{setTabType('QUESTION')}}>
                    <div id={'cmsHeaderQuestionSearch'} ref={questionTabDivRef}></div>
                </Tab>
                <Tab tab={'Question Set'} tabpanelclassname={'ch-search-items-blk'} onClick={()=>{setTabType('QUESTION_SET')}}>
                    <div id={'cmsHeaderQuestionSetSearch'} ref={questionSetTabDivRef}></div>
                </Tab>
            </Tabs>
            {isLoading &&
                <div style={{display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
                    <CircularLoader/>
                </div>
            }
        </>
    );
}

export default CMSSearch;